import { useMemo } from 'react';
import { useSelector } from '@bonanza-social/toolkit/state';
import { isUserOnBreak } from '@bonanza-social/account';
import { selectDailyScratcher, selectDailyScratcherStatus } from '../state';

const useDailyScratcher = () => {
  const dailyScratcher = useSelector(selectDailyScratcher);
  const dailyScratcherStatus = useSelector(selectDailyScratcherStatus);
  const isUserTimedOut = useSelector(isUserOnBreak);

  const isVisible = useMemo(() => {
    return (
      dailyScratcherStatus !== 'NotAvailable' &&
      dailyScratcher &&
      !isUserTimedOut
    );
  }, [dailyScratcherStatus, dailyScratcher, isUserTimedOut]);

  return {
    dailyScratcher,
    dailyScratcherStatus,
    isVisible,
  };
};

export default useDailyScratcher;
